var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1 1.75C7.70442 1.75 5.07724 4.72603 5.49841 8.09536L5.57776 8.73021C5.69388 9.65916 5.35455 10.5871 4.66654 11.2219C3.24086 12.5375 2.84477 14.6315 3.69142 16.3769L3.79477 16.59C4.54092 18.1282 6.05598 19.1356 7.74728 19.2409L7.93556 19.5636C8.94835 21.2998 10.5264 22.25 12.1834 22.25C13.8404 22.25 15.4184 21.2998 16.4312 19.5636L16.6225 19.2358C18.0431 19.1235 19.3385 18.3513 20.1111 17.1373C21.2932 15.2799 20.9801 12.8432 19.3668 11.345L19.3229 11.3042C18.5844 10.6183 18.2208 9.61912 18.3458 8.61901L18.4104 8.10208C18.832 4.72918 16.202 1.75 12.8029 1.75H11.1ZM8.16917 17.75C8.17819 17.7498 8.18721 17.7498 8.19621 17.75H16.1706C16.1796 17.7498 16.1886 17.7498 16.1976 17.75H16.2623C17.3092 17.75 18.2835 17.2152 18.8456 16.332C19.6391 15.0852 19.4289 13.4497 18.3461 12.4441L18.3022 12.4033C17.2102 11.3892 16.6725 9.91174 16.8574 8.43296L16.922 7.91603C17.2317 5.43841 15.2998 3.25 12.8029 3.25H11.1C8.60667 3.25 6.67757 5.43526 6.98682 7.90931L7.06618 8.54416C7.24234 9.95345 6.72755 11.3611 5.68379 12.3243C4.74404 13.1915 4.48294 14.5718 5.04102 15.7223L5.14438 15.9353C5.68275 17.0452 6.8079 17.75 8.04147 17.75H8.16917ZM12.1834 20.75C11.2623 20.75 10.2795 20.2877 9.52013 19.25H14.8467C14.0873 20.2877 13.1045 20.75 12.1834 20.75Z",
    fill: "#3D424D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.bfa004d734656474c171a9d34145f8b1.svg";
export { ForwardRef as ReactComponent };